import { IPA_ADDITIONAL_CONTRACTS } from '../../../../../utils/ipaAccess';

export const PRICE_ARCHITECTURE_CONTRACT = IPA_ADDITIONAL_CONTRACTS.PRICE_ARCHITECTURE;

export const hasPriceArchitectureAccess = (contratosAdicionais: readonly string[]) => contratosAdicionais.includes(PRICE_ARCHITECTURE_CONTRACT);

// Produto do usuario que o gateway exige nas rotas que o submenu chama: PRICING para as rotas de
// Precificacao, ANY para as que aceitam Negociacao ou Precificacao.
export type SubmenuProduct = 'ANY' | 'PRICING';

export type SubmenuProductRule = {
  product: SubmenuProduct;
  additional?: string;
  requiresClientNegotiation?: boolean;
};

export type UserProductsContext = {
  hasPricing: boolean;
  hasNegotiation: boolean;
  clientHasNegotiation: boolean;
  contratosAdicionais: readonly string[];
};

const hasProduct = (product: SubmenuProduct, context: UserProductsContext) => {
  if (product === 'PRICING') return context.hasPricing;
  return context.hasPricing || context.hasNegotiation;
};

// O produto do cliente sozinho nao basta: o gateway recusaria a gravacao.
export const isSubmenuVisibleByProduct = (rule: SubmenuProductRule, context: UserProductsContext) =>
  hasProduct(rule.product, context) &&
  (rule.additional == null || context.contratosAdicionais.includes(rule.additional)) &&
  (!rule.requiresClientNegotiation || context.clientHasNegotiation);
